var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetanymail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1379 1842 c-71 -46 -143 -142 -121 -164 7 -7 15 -1 25 18 22 43 96 124 113 124 8 0 22 -13 32 -29 17 -30 55 -41 138 -41 41 0 42 12 8 58 -51 66 -124 79 -195 34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264 1578 c-80 -83 -184 -202 -184 -212 0 -17 25 4 143 119 78 77 127 133 127 145 0 11 -3 20 -8 20 -4 0 -39 -33 -78 -72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595 1529 c-431 -153 -426 -151 -414 -165 7 -8 30 -14 56 -14 37 0 63 11 153 65 60 35 151 81 202 100 87 34 113 46 92 44 -5 -1 -45 -14 -89 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 1367 c-14 -7 -34 -29 -45 -49 -28 -53 -13 -106 37 -131 49 -24 76 -15 84 28 8 44 0 65 -26 65 -24 0 -26 -9 -5 -24 22 -16 8 -56 -20 -56 -50 0 -74 79 -39 129 14 20 23 23 60 18 48 -5 59 8 18 23 -32 12 -34 12 -64 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983 1295 c-12 -14 -17 -27 -12 -30 5 -3 6 -32 3 -64 -6 -49 -4 -59 11 -64 25 -10 39 3 20 17 -14 10 -15 20 -8 57 5 24 14 45 21 45 25 3 25 4 10 17 -9 6 -18 20 -20 29 -3 15 -6 14 -25 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058 1228 c-9 -51 -14 -95 -12 -97 5 -5 88 -20 93 -16 10 10 -14 25 -40 25 -22 0 -29 5 -29 19 0 39 11 51 47 51 20 0 32 4 28 10 -3 6 -16 10 -29 10 -31 0 -35 7 -27 38 6 23 12 27 39 24 41 -4 42 14 1 22 -55 11 -55 10 -71 -86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856 1281 c-28 -31 -32 -85 -7 -110 21 -21 71 -29 71 -11 0 6 -9 10 -19 10 -21 0 -51 25 -51 42 0 7 17 9 45 6 l45 -6 0 34 c0 51 -51 72 -84 35z m62 -24 c3 -13 -3 -17 -27 -17 -33 0 -39 8 -19 28 17 17 42 11 46 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187 1243 c-3 -5 -8 -36 -12 -70 -8 -71 8 -89 19 -21 8 47 21 68 43 68 12 0 14 -12 11 -59 -5 -92 11 -92 26 1 6 35 28 54 48 42 6 -4 7 -29 3 -65 -7 -62 7 -84 19 -28 16 83 -1 128 -44 114 -12 -4 -27 -1 -35 5 -8 6 -22 10 -32 8 -10 -1 -23 1 -30 5 -6 4 -14 4 -16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1586 1229 c-24 -108 -32 -189 -18 -189 13 0 43 193 32 204 -5 5 -11 -1 -14 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1522 1229 c2 -6 8 -10 13 -10 5 0 11 4 13 10 2 6 -4 11 -13 11 -9 0 -15 -5 -13 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695 1210 c-4 -6 -3 -16 3 -22 6 -6 12 -6 17 2 4 6 3 16 -3 22 -6 6 -12 6 -17 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400 1201 c0 -5 10 -11 22 -13 13 -2 24 -11 26 -20 3 -14 -3 -18 -25 -18 -16 0 -34 -5 -41 -12 -15 -15 -16 -55 -1 -64 16 -9 79 -14 79 -6 1 4 5 27 10 52 10 55 -7 90 -45 90 -14 0 -25 -4 -25 -9z m50 -77 c0 -15 -22 -44 -34 -44 -16 0 -29 27 -20 41 6 10 54 13 54 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517 1177 c-12 -32 -19 -127 -9 -127 8 0 32 100 32 133 0 12 -18 7 -23 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675 1100 c-9 -74 -9 -74 3 -78 5 -1 13 23 17 54 4 31 9 63 12 71 3 7 -1 13 -10 13 -11 0 -17 -16 -22 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753 1135 c-27 -19 -39 -75 -24 -104 14 -26 52 -36 79 -22 29 16 47 74 31 103 -22 41 -49 49 -86 23z m55 -17 c32 -32 -8 -117 -43 -88 -20 16 -19 64 1 84 19 19 26 20 42 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 1044 c0 -17 22 -14 28 4 2 7 -3 12 -12 12 -9 0 -16 -7 -16 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091 1004 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115 876 c9 -57 41 -118 81 -157 31 -30 40 -34 93 -34 47 0 66 6 100 28 23 15 39 32 36 36 -2 5 -34 12 -70 16 -62 6 -68 5 -101 -20 l-36 -28 -29 30 c-16 16 -41 60 -55 98 -19 52 -24 60 -19 31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetanymail);
export default __webpack_public_path__ + "static/media/getanymail.72f25dc526a546d2c796882d0c0bd9eb.svg";
export { ForwardRef as ReactComponent };